import { render, staticRenderFns } from "./PositionComp.vue?vue&type=template&id=f78858a2&"
import script from "./PositionComp.vue?vue&type=script&lang=js&"
export * from "./PositionComp.vue?vue&type=script&lang=js&"
import style0 from "./PositionComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports